import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ResearchFavoriteService } from './research-favorite-service';
import { useResearchDetailsCache } from '../cache/useResearchDetailsCache';

interface ToggleResearchFavoriteParams {
  researchId: string;
  isFavorited: boolean;
}

export const useToggleResearchFavorite = () => {
  const queryClient = useQueryClient();
  const { invalidateCache } = useResearchDetailsCache();

  return useMutation({
    mutationFn: async (params: ToggleResearchFavoriteParams) => {
      await ResearchFavoriteService.toggleFavorite(params);
    },
    onSuccess: (_, variables) => {
      // ✅ CRITICAL FIX: Invalidate in-memory cache first
      invalidateCache(variables.researchId);
      
      // Invalidate and refetch the research library data - fixed key to match query
      queryClient.invalidateQueries({
        queryKey: ['research-library-list'],
      });
      
      // Invalidate the specific research item details cache
      queryClient.invalidateQueries({
        queryKey: ['research-item-details', variables.researchId],
      });
      
      // Also invalidate all research item details to be safe
      queryClient.invalidateQueries({
        queryKey: ['research-item-details'],
      });
      
      // ✅ CRITICAL FIX: Also invalidate generated research details cache
      // This ensures that Project Research cards update when lightbox like button is clicked
      queryClient.invalidateQueries({
        queryKey: ['generated-research-details'],
      });
      
      // Also invalidate generated research cache (for suggestions)
      queryClient.invalidateQueries({
        queryKey: ['generated-research'],
      });
    },
    onError: (error) => {
      console.error('Failed to toggle favorite:', error);
    },
  });
};
